import { render, staticRenderFns } from "./userTagManage.vue?vue&type=template&id=df8cab6a&scoped=true&"
import script from "./userTagManage.vue?vue&type=script&lang=js&"
export * from "./userTagManage.vue?vue&type=script&lang=js&"
import style0 from "./userTagManage.vue?vue&type=style&index=0&id=df8cab6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8cab6a",
  null
  
)

export default component.exports